import { u as p, v as d } from "./reactive-element-BDpydG15-BOs0_4cf.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const l = { attribute: !0, type: String, converter: p, reflect: !1, hasChanged: d }, h = (e = l, s, t) => {
  const { kind: a, metadata: n } = t;
  let o = globalThis.litPropertyMetadata.get(n);
  if (o === void 0 && globalThis.litPropertyMetadata.set(n, o = /* @__PURE__ */ new Map()), o.set(t.name, e), a === "accessor") {
    const { name: r } = t;
    return { set(c) {
      const i = s.get.call(this);
      s.set.call(this, c), this.requestUpdate(r, i, e);
    }, init(c) {
      return c !== void 0 && this.P(r, void 0, e), c;
    } };
  }
  if (a === "setter") {
    const { name: r } = t;
    return function(c) {
      const i = this[r];
      s.call(this, c), this.requestUpdate(r, i, e);
    };
  }
  throw Error("Unsupported decorator location: " + a);
};
function y(e) {
  return (s, t) => typeof t == "object" ? h(e, s, t) : ((a, n, o) => {
    const r = n.hasOwnProperty(o);
    return n.constructor.createProperty(o, r ? { ...a, wrapped: !0 } : a), r ? Object.getOwnPropertyDescriptor(n, o) : void 0;
  })(e, s, t);
}
export {
  y as property,
  h as standardProperty
};
